const LAST_RELOADED_AT_KEY = 'hanly-chunk-reload-at';
const RELOAD_COOLDOWN_MS = 60_000;

/**
 * デプロイ後に旧バージョンのchunkを取得できなくなった場合、リロードして最新版に復旧する。
 *
 * dynamic import しているモジュール（AG Grid など）は初回描画時に取得するため、
 * タブを開いたままデプロイが行われると取得が404になり画面が壊れる。
 * Vite は dynamic import の読み込みに失敗すると window に `vite:preloadError` を発火するので、
 * これを拾って読み直す。
 *
 * - オフライン時はリロードしても復旧しないため何もしない
 * - リロードしても直らない場合に繰り返さないよう、直近のリロード時刻を sessionStorage に記録して
 *   クールダウンを設ける。sessionStorage が使えない環境では例外でそのまま中断するので、
 *   クールダウンが成立しないまま自動リロードすることはない
 */
export const registerChunkReloadHandler = () => {
  window.addEventListener('vite:preloadError', () => {
    if (!window.navigator.onLine) return;

    const now = Date.now();
    const lastReloadedAt = Number(window.sessionStorage.getItem(LAST_RELOADED_AT_KEY)) || 0;
    if (now - lastReloadedAt < RELOAD_COOLDOWN_MS) return;

    window.sessionStorage.setItem(LAST_RELOADED_AT_KEY, String(now));
    window.location.reload();
  });
};
